import type { MigrationStrategies } from "./_types/migration-strategies";

export const SYNC_CHECKPOINT_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => oldDoc,
  3: (oldDoc) => oldDoc,
  4: (oldDoc) => oldDoc,
  5: (oldDoc) => oldDoc,
  6: (oldDoc) => oldDoc,
  7: (oldDoc) => oldDoc,
  8: (oldDoc) => oldDoc,
  9: (oldDoc) => oldDoc,
  10: (oldDoc) => oldDoc,
  11: (oldDoc) => oldDoc,
  12: (oldDoc) => oldDoc,
  13: (oldDoc) => oldDoc,
  14: (oldDoc) => oldDoc,
  15: (oldDoc) => oldDoc,
  16: (oldDoc) => oldDoc,
};
